// Число на языке интерфейса: «3 250», «1,5».
export const formatNumber = (
  value: number,
  locale: string,
  options: Intl.NumberFormatOptions = { maximumFractionDigits: 0 },
): string => new Intl.NumberFormat(locale, options).format(value);
